import { render, staticRenderFns } from "./WindowsVersion.vue?vue&type=template&id=0cf0989f&"
import script from "./WindowsVersion.vue?vue&type=script&lang=js&"
export * from "./WindowsVersion.vue?vue&type=script&lang=js&"
import style0 from "./WindowsVersion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports